import { createSelector } from '@reduxjs/toolkit';
import { ReferentialKey } from 'api/referential';
import { RootState } from 'app/store';

export const selectReferentialByKey = (key?: ReferentialKey) =>
  createSelector(
    (state: RootState) => state.referential.referentials,
    referentials => key !== undefined ? referentials[key] : null
  );
